ConnectStore = require 'components/enhancers/connect_store'
NMAListActions = require 'actions/nma_list_actions'
NMAListStore = require 'stores/nma_list_store'
NMAQuestionStore = require 'stores/nma_question_store'
mediator = require 'mediator'
{
  buildNmaPrintoutTableData
} = require 'lib/nma_printout_table_helper'
{ CommonComparatorTableWithI18n, TableSettingsContext } = NmaComponents
{ useEffect } = React

storeConnector =
  NMAListStore: (Store) ->
    isFetchingNmaQuestions: Store.isFetching()
    nmaQuestions: Store.getQuestions()
  NMAQuestionStore: (Store) ->
    nmaOutcomes: Store.getOutcomes()

NmaTablePrintout = ({
  isFetchingNmaQuestions
  nmaOutcomes
  nmaQuestions
  props
  qId
  settings
  vizConfig
}) ->
  initialProps = props
  initialSettings = settings

  useEffect(
    ->
      shouldFetch = qId? and (not initialProps? or not initialSettings?) and not isFetchingNmaQuestions and
        (nmaQuestions.isEmpty() or nmaOutcomes.isEmpty())
      return undefined unless shouldFetch

      cancelled = false
      _.defer ->
        return if cancelled
        NMAListActions.fetchAllQuestionsAndOutcomes dbId: mediator.project.id

      ->
        cancelled = true
    [qId, initialProps, initialSettings, isFetchingNmaQuestions, nmaQuestions, nmaOutcomes]
  )

  tablePropsData = initialProps
  tableSettings = initialSettings

  unless tablePropsData? and tableSettings?
    question = nmaQuestions.find (question) -> question.get('_id') is qId
    tableData = buildNmaPrintoutTableData question, nmaOutcomes, vizConfig ? {}
    tablePropsData = tableData?.props
    tableSettings = tableData?.settings

  unless tablePropsData? and tableSettings?
    return <div className="nma-table-printout nma-table-printout-empty">
      {i18next.t 'nma:viz_app.common.no_data_found'}
    </div>

  tableProps = _.extend {}, tablePropsData, i18nInstance: i18next

  <div className="nma-table-printout">
    <TableSettingsContext.Provider value={tableSettings}>
      <CommonComparatorTableWithI18n {...tableProps} />
    </TableSettingsContext.Provider>
  </div>

module.exports = ConnectStore NmaTablePrintout,
  [NMAListStore, NMAQuestionStore],
  storeConnector
